/* ============================================================
   STOQ — The Quiet Motion（共通モーションJS）
   ベース基盤：scroll-driven animations 非対応環境向けの
   IntersectionObserver フォールバックで .is-inview を付与する。
   実装パターン：#1 Gallery Reveal / #6 Counter Polish。
   予算：<8KB gzip。ライブラリ不使用。
   ============================================================ */
(function () {
  'use strict';

  var de = document.documentElement;
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* #6 Counter Polish：[data-counter] を 1.2s ease-out で1回だけカウントアップ。
     数値は承認済みスペック・実績値のみ（マークアップ側で管理）。 */
  function runCounter(el) {
    var target = parseInt(el.getAttribute('data-counter'), 10);
    if (!target || el.dataset.counted) return;
    el.dataset.counted = '1';
    var start = null;
    var DUR = 1200;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      el.textContent = Math.round(target * eased).toLocaleString('ja-JP');
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-reveal]');
    var counters = document.querySelectorAll('[data-counter]');
    if (!nodes.length && !counters.length) return;

    // JS実行時のみ隠し状態を有効化（CSS側は html.stoq-motion でゲート）。
    // 全 reveal 対象はファーストビュー外のため、ここでの初期hideはチラつかない。
    if (nodes.length) de.classList.add('stoq-motion');

    // reduce 指定 or IO非対応 → 即時表示（演出なし・カウンタは最終値のまま）
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-inview');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            io.unobserve(e.target); // 1回だけ
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);

    if (counters.length) {
      var cio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              runCounter(e.target);
              cio.unobserve(e.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      for (var k = 0; k < counters.length; k++) cio.observe(counters[k]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
